export default __webpack_public_path__ + "static/media/spotify-zik.da24a198.png";